import React from "react";

import '../../../../../Utils/Css/Menu.css'

export default function Menu() {
  return (
    <div
      className="menuContainer primary white"
    >
      <div className="menuExchange">IP</div>
      <div className="menuSymbol">ID</div>
      <div className="menuSymbol">DEVICE</div>
      <div className="menuLtt">LOGIN-IN-DATE</div>
      <div className="menuLtt">LOGOUT-IN-DATE</div>
      <div className="menuLtt">DATE</div>
    </div>
  );
}
